module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/link-9c4fc01e81d6eedad63335321783587e.svg";